import {IColumnItem} from "@ui/tableCustom/types/columns";

import {copyObj} from "@helpers/transform/transform";


const buildEmptyCellPdf = <T>(column:IColumnItem<T>,type:'colSpan' | 'rowSpan')=>{
    return {

    }
}
export const fillEmptyCellsPdf = <T>(columns: IColumnItem<T>[]): IColumnItem<T>[] => {
    let columnsWidthEmptySpan: IColumnItem<T>[] = [];
    columns.forEach((column, colIndex) => {
        columnsWidthEmptySpan.push(column)
        if (column.colSpan > 1) {
            const emptyCell = buildEmptyCellPdf(column, 'colSpan')
            for (let i = 1; i < column.colSpan; i++) {
                columnsWidthEmptySpan.push(emptyCell as IColumnItem<T>)
            }

        }
    });

    return columnsWidthEmptySpan;
};
export const fillEmptyCellsMatrixPdf = <T>(matrixProps: IColumnItem<T>[][]): IColumnItem<T>[][] => {
    const matrix: IColumnItem<T>[][] = copyObj(matrixProps)
    let matrixWidthEmptySpan: IColumnItem<T>[][] = [];
    let mapRows: any = {}
    matrix.forEach((columns, rowIndex) => {
        let rows: IColumnItem<T>[] = []
        columns.forEach((column, colIndex) => {
            rows.push(column)
            const emptyCell = buildEmptyCellPdf(column, 'colSpan')
            if (column.colSpan > 1) {
                for (let i = 1; i < column.colSpan; i++) {
                    rows.push(emptyCell as IColumnItem<T>)
                }

            }
        });
        matrixWidthEmptySpan.push(rows)

    });

    matrixWidthEmptySpan.forEach((columns, rowIndex) => {
        columns.forEach((column, colIndex) => {
            if (column.rowSpan > 1) {
                for (let i = 1; i < column.rowSpan; i++) {
                    mapRows[rowIndex + i] = {
                        ...(mapRows[rowIndex + 1] ?? {}),
                        [colIndex]: column
                    }
                }
            }
        });

    });

    if (!Object.keys(mapRows)?.length) {
        return matrixWidthEmptySpan
    }
    let matrixWithEmptySpanAndRows: IColumnItem<T>[][] = [];
    matrixWidthEmptySpan.forEach((columns, rowIndex) => {
        const emptyRows = rowIndex in mapRows ? mapRows[rowIndex] : {};
        let rows: IColumnItem<T>[] = [...columns]
        for (const index in emptyRows) {
            const column = emptyRows[index];
            const emptyCell = buildEmptyCellPdf(column, 'rowSpan')
            rows.splice(Number(index), 0, emptyCell as IColumnItem<T>);
        }
        matrixWithEmptySpanAndRows.push(rows)
    });

    return matrixWithEmptySpanAndRows;
};
